import { useTranslation } from "react-i18next";
import { CalendarBlank, Clock } from "@phosphor-icons/react";
import { useNavigation } from "../context/NavigationContext";
import { getRelatedArticles } from "../data/articles";

const RelatedArticles = ({ currentSlug }) => {
  const { t, i18n } = useTranslation();
  const { navigateTo } = useNavigation();
  const related = getRelatedArticles(currentSlug, i18n.language, 3);

  if (!related.length) return null;

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString(i18n.language, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  return (
    <section className="mt-16 pt-10 border-t border-white/10" data-testid="related-articles">
      <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8">
        {t("blog.related")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {related.map((article) => (
          <button
            key={article.slug}
            type="button"
            onClick={() => navigateTo("blog-article", article.slug)}
            data-testid={`related-article-${article.slug}`}
            className="group text-left rounded-2xl overflow-hidden bg-white/5 border border-white/10 hover:border-lumina-violet/50 hover:bg-white/10 transition-all"
          >
            <div className="aspect-[2/1] overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                loading="eager"
                decoding="async"
                width="800"
                height="400"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-3 mb-3 text-xs text-gray-400">
                <div className="flex items-center gap-1">
                  <CalendarBlank size={13} weight="regular" />
                  <span>{formatDate(article.date)}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Clock size={13} weight="regular" />
                  <span>{t("blog.readTimeFormat", { min: article.readTime })}</span>
                </div>
              </div>
              <h3 className="text-base font-semibold text-white mb-2 line-clamp-2 group-hover:text-lumina-violet transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-gray-400 line-clamp-2">{article.meta}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default RelatedArticles;
